import React from "react";
import { Tooltip } from "@sscs/ui";
import { AutorenewIcon, BlockIcon, LightbulbIcon as EmojiObjectsIcon, HealingIcon, MenuBookIcon, SearchIcon, } from "@sscs/ui/icons";
import styles from "./remediationSteps.module.scss";
const STEP_DATA = {
    consult: { Icon: MenuBookIcon, tooltip: "Learn more" },
    fix: { Icon: HealingIcon, tooltip: "Apply changes" },
    investigate: { Icon: SearchIcon, tooltip: "Inspect software" },
    practice: { Icon: EmojiObjectsIcon, tooltip: "Improve processes" },
    stop: { Icon: BlockIcon, tooltip: "Prevent damage" },
    update: { Icon: AutorenewIcon, tooltip: "Perform updates" },
};
const RemediationSteps = ({ steps, }) => {
    return (React.createElement("div", { className: styles.steps }, steps.map(({ type, content }, index) => {
        const { Icon, tooltip } = STEP_DATA[type];
        return (React.createElement("div", { key: index, className: styles["step-content"] },
            React.createElement(Tooltip, { trigger: "graphic", title: tooltip },
                React.createElement(Icon, { className: styles["type-icon"] })),
            React.createElement("span", null, content)));
    })));
};
export default RemediationSteps;
//# sourceMappingURL=RemediationSteps.js.map